import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
import useChunkedSteps from "../../atlas/presets/stepper/useChunkedSteps.js";
export var StepType;
(function (StepType) {
    StepType["active"] = "active";
    StepType["complete"] = "complete";
    StepType["incomplete"] = "incomplete";
})(StepType = StepType || (StepType = {}));
export const emptyStepperPresets = {
    advancedStepper: {
        activeStep: -1,
        alternativeLabel: true,
        sx: {},
    },
    constants: {
        StepType: {},
    },
    hooks: {
        useChunkedSteps: useChunkedSteps,
    },
    components: {
        EllipsisStepLabel: () => _jsx(_Fragment, {}),
        VisibleStepLabel: () => _jsx(_Fragment, {}),
        VisibleStep: () => _jsx(_Fragment, {}),
    },
};
//# sourceMappingURL=stepper.js.map